import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import OrderItem from '../../components/OrderItem';
import axios from 'axios';
import { dateFormat, endpointApi } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/actions/loader.action';
import { logout } from '../../redux/actions/auth.action';
import { useLocation, useNavigate } from 'react-router-dom';
import { changeElementInList, getOrders } from '../../redux/actions/order.action';
import SearchClient from '../../components/SearchClient';
import Paginate from '../../components/Paginate';

export default function OrdersPage() {
  const jwt_access = localStorage.getItem('jwt_access');
  const { me } = useSelector(state => state.auth);
  const orders = useSelector(state => state.orders);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const modalRef = useRef(null);
  const detailsModalRef = useRef(null);
  const updateModalRef = useRef(null);
  const addFormRef = useRef(null);
  const updateFormRef = useRef(null);
  const [modal, setModal] = useState(null);
  const [actionModal, setActionModal] = useState(null);
  
  const [order, setOrder] = useState(null);

  const [items, setItems] = useState([{key: 0}]);
  const [code, setCode] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [purchaseOrder, setPurchaseOrder] = useState("");
  const [client, setClient] = useState(null);
  const [status, setStatus] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [delivryNoteDate, setDelivryNoteDate] = useState("");
  const [withdrawalFeesViaMvola, setWithdrawalFeesViaMvola] = useState("");
  const [delivryFees, setDelivryFees] = useState("");
  const [shippingFees, setShippingFees] = useState("");
  const [delivryNoteAddress, setDelivryNoteAddress] = useState("");
  const [delivryNoteOrderCode, setDelivryNoteOrderCode] = useState("");
  const [delivryNoteStatus, setDelivryNoteStatus] = useState("");
  const [discount, setDiscount] = useState(0.00);
  const [generateInvoice, setGenerateInvoice] = useState(false);
  const [generateDelivryNote, setGenerateDelivryNote] = useState(false);
  const [isCodeTouched, setIsCodeTouched] = useState(false);
  const [isOrderDateTouched, setIsOrderDateTouched] = useState(false);
  const [isPurchaseOrderTouched, setIsPurchaseOrderTouched] = useState(false);
  const [isInvoiceDateTouched, setIsInvoiceDateTouched] = useState(false);
  const [isInvoiceStatusTouched, setIsInvoiceStatusTouched] = useState(false);
  const [isDelivryNoteDateTouched, setIsDelivryNoteDateTouched] = useState(false);
  const [isDelivryNoteOrderCodeTouched, setIsDelivryNoteOrderCodeTouched] = useState(false);
  const [isDelivryNoteAddressTouched, setIsDelivryNoteAddressTouched] = useState(false);
  const [isDelivryNoteStatusTouched, setIsDelivryNoteStatusTouched] = useState(false);
  const [isDiscountTouched, setIsDiscountTouched] = useState(false);
  const [isStatusTouched, setIsStatusTouched] = useState(false);
  const [key, setKey] = useState(1);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    dispatch(getOrders(location, navigate));
  }, [location, dispatch, navigate]);

  const addItem = () => {
    setItems([...items, {key: key + 1}]);
    setKey(key + 1);
  }

  const removeItem = (key) => {
    if(items.length > 1)
      setItems(items.filter(item => item.key !== key));
  }

  useEffect(() => {
    const clickOutsideActionModal = (e) => {
      const $actionModals = document.querySelectorAll('.actions>ul');
      $actionModals.forEach($actionModal => {
        if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
          setActionModal(null);
        }
      });
    }
    document.addEventListener('click', clickOutsideActionModal);
    return () => {
      document.removeEventListener('click', clickOutsideActionModal);
    }
  }, []);

  const handleSubmit = async(e) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setErrors(null);
    const data = new FormData(e.target);
    await axios.post(`${ endpointApi }orders`, data, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${ jwt_access }`          
                }
              })
              .then(({ data }) => {
                dispatch(getOrders(location, navigate));
                setOrder(data);
                setModal("details");
              })
              .catch(err => {
                if(err.response.status === 401){
                  dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
              })
              .finally(() => {
                dispatch(setLoading(false));
              });
  }
  
  const handleSubmitUpdate = async(e) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setErrors(null);
    const data = new FormData(e.target);
    await axios.put(`${ endpointApi }orders/${ order?.id }`, data, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${ jwt_access }`          
                }
              })
              .then(({ data }) => {
                dispatch(getOrders(location, navigate));
                setOrder(data);
                setModal("details");
              })
              .catch(err => {
                if(err.response.status === 401){
                  dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
              })
              .finally(() => {
                dispatch(setLoading(false));
              });
  }

  useEffect(() => {
    const clickModalOutside = (e) => {
      if((detailsModalRef.current &&  detailsModalRef.current === e.target && detailsModalRef.current.classList.contains('active')) || (updateModalRef.current &&  updateModalRef.current === e.target && updateModalRef.current.classList.contains('active')) || (modalRef.current && modalRef.current === e.target && modalRef.current.classList.contains('active')) || e.target.classList.contains('_modal-close')){
        setModal(null);
      }
    }
    document.addEventListener('click', clickModalOutside);

    return () => {
      document.removeEventListener('click', clickModalOutside);
    }
  }, []);

  useEffect(() => {
    if(modal){
      const $modals = document.querySelectorAll('._modal-content');
      $modals.forEach($modal => {
        $modal.scrollTop = 0;
      })
    }

    if(modal !== "update"){
      if(addFormRef.current)
        addFormRef.current.reset();
    
    if(updateFormRef.current && modal === null)
        updateFormRef.current.reset();

      setItems([{key: 1}]);
      setCode("");
      setOrderDate("");
      setPurchaseOrder("");
      setClient(null);
      
      if(modal === null)
        setOrder(null);

      setStatus("");
      setIsCodeTouched(false);
      setIsOrderDateTouched(false);
      setIsPurchaseOrderTouched(false);
      setIsStatusTouched(false);
      setGenerateInvoice(false);
      setGenerateDelivryNote(false);

      setErrors(null);
    }
  }, [modal]);

  useEffect(() => {
    if(order && modal === 'update'){
      if(addFormRef.current)
        addFormRef.current.reset();

      setCode(order.code);
      setOrderDate(order.order_date);
      setPurchaseOrder(order.purchase_order ? order.purchase_order : '');
      setStatus(order.status);
      setClient(order.client);
      setItems([]);
    }
  }, [modal, order]);
  
  useEffect(() => {
    if(generateDelivryNote === false){
      setDelivryNoteDate("");
      setDelivryNoteAddress("");
      setDelivryNoteOrderCode("");
      setDelivryNoteStatus("");
      setIsDelivryNoteDateTouched(false);
      setIsDelivryNoteOrderCodeTouched(false);
      setIsDelivryNoteAddressTouched(false);
      setIsDelivryNoteStatusTouched(false);
    }
  }, [generateDelivryNote]);

  useEffect(() => {
    if(generateInvoice === false){
      setInvoiceDate("");
      setInvoiceDueDate("");
      setInvoiceStatus("");
      setWithdrawalFeesViaMvola("");
      setDelivryFees("");
      setShippingFees("");
      setDiscount(0.00);
      setIsDiscountTouched(false);
      setIsInvoiceDateTouched(false);
      setIsInvoiceStatusTouched(false);
    }
  }, [generateInvoice]);

  const deteteOrderItem = async(id) => {
    dispatch(setLoading(true));
    try {
      const { data } = await axios.delete(`${ endpointApi }orders/${ order?.id }/remove-item/${ id }`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${ jwt_access }`
        }  
      });
      
      setOrder(data);
      dispatch(changeElementInList(data));
    } catch (err) {
      if(err.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
    dispatch(setLoading(false));
  }

  useEffect(() => {
    if(!jwt_access){
      navigate('/login?redirect_to=' + location.pathname + location.search);
    }
  }, [location, navigate, jwt_access]);

  return (
    me &&
    <HelmetProvider>
        <Helmet>
            <title>Liste des commandes - Société Mikalo</title>
        </Helmet>
        
        <Header />

        <Nav />

        <main id="main">
          <div className='title d-flex justify-content-between'>
            <h1>Commandes</h1>
            <button type='button' onClick={ () => {
              setModal('add');
            } } className='btn btn-primary'><i className='fa fa-plus'></i> Nouveau</button>
          </div>

          <div ref={ modalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
            <div className='_modal-content'>
              <div className='_modal-head'>
                <h4>Ajouter une commande</h4>
                <button className='_modal-close'>&times;</button>
              </div>
              <div className='_modal-body'>
                <form ref={ addFormRef } className='form' onSubmit={ handleSubmit }>
                  { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                  <div className='mb-3'>
                    <label htmlFor='order_date' className='required'>Date de commande</label>
                    <input type='date' name='order_date' id='order_date' required className='form-control' value={ orderDate } onChange={ (e) => setOrderDate(e.target.value) } onBlur={ () => setIsOrderDateTouched(true) } />
                    { isOrderDateTouched && orderDate.length === 0 && <div className='form-error'>Veuillez saisir la date de la commande.</div> }
                    { errors && errors.order_date && <div className='form-error'>{ errors.order_date[0] }</div> }
                  </div>
                  
                  <div className='mb-3'>
                    <label htmlFor='purchase_order'>N° de bon de commande</label>
                    <input type='text' name='purchase_order' id='purchase_order' placeholder='N° de bon de commande' className='form-control' value={ purchaseOrder } onChange={ (e) => setPurchaseOrder(e.target.value) } onBlur={ () => setIsPurchaseOrderTouched(true) } />
                    { isPurchaseOrderTouched && purchaseOrder.length > 0 && purchaseOrder.length < 2 && <div className='form-error'>Le numéro de bon de commande est trop court. Veuillez saisir au moins 2 caractères.</div> }
                    { errors && errors.purchase_order && <div className='form-error'>{ errors.purchase_order[0] }</div> }
                  </div>
                  
                  <div className='mb-3'>
                    <label htmlFor='client_id' className='required'>Client</label>
                    <input type='hidden' name='client_id' className='form-control' value={ client ? client.id : "" } />
                    <SearchClient updateClient={ setClient } required={ true } reset={ modal !== "add" } defaultValue={ client } />
                    { errors && errors.client_id && <div className='form-error'>{ errors.client_id[0] }</div> }
                  </div>

                  { items.map((item, index) => {
                    return(
                      <OrderItem item={ index } itemKey={ item.key } key={ item.key } onRemove={ removeItem } errors={ errors } reset={ modal !== "add" } />
                    )
                  }) }
                  
                  <div className='mb-3 text-end'>
                    <button type='button' onClick={ addItem } className='btn btn-sm btn-info'><i className='fa fa-plus'></i> Ajouter un produit</button>
                  </div>

                  <div className='mb-3'>
                    <label htmlFor='status' className='required'>Etat de la commande</label>
                      <select id='status' name='status' required className='form-control' value={ status } onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                        <option value="">Sélectionner...</option>
                        <option value="Pending">En attente</option>
                        <option value="Confirmed">Confirmée</option>
                        <option value="Shipped">Expédiée</option>
                        <option value="Delivered">Livrée</option>
                        <option value="Cancelled">Annulée</option>
                        <option value="Returned">Retournée</option>
                      </select>
                      { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la commande.</div> }
                      { errors && errors.status && <div className='form-error'>{ errors.status[0] }</div> }
                  </div>

                  <div className='mb-3'>
                    <label>
                      <input type='checkbox' name='generate_delivry_note' value={ generateDelivryNote } onChange={ (e) => setGenerateDelivryNote(e.target.checked) } />
                      <div></div>
                      Je voulais générer un bon de livraison
                    </label>
                  </div>
                  
                  { generateDelivryNote && <>
                    <h6>Bon de livraison</h6>
                    <div className='mb-3'>
                      <label htmlFor='delivry_note_order_code' className='required'>Code commande</label>
                      <input type='text' id='delivry_note_order_code' name='delivry_note_order_code' placeholder='Code commande' required className='form-control' value={ delivryNoteOrderCode } onChange={ (e) => setDelivryNoteOrderCode(e.target.value) } onBlur={ () => setIsDelivryNoteOrderCodeTouched(true) } />
                      { isDelivryNoteOrderCodeTouched && delivryNoteOrderCode.length === 0 && <div className='form-error'>Veuillez saisir la date livraison.</div> }
                      { errors && errors.delivry_note_order_code && <div className='form-error'>{ errors.delivry_note_order_code[0] }</div> }
                    </div>
                    
                    <div className='mb-3'>
                      <label htmlFor='delivry_note_date' className='required'>Date de livraison</label>
                      <input type='date' id='delivry_note_date' name='delivry_note_date' required className='form-control' value={ delivryNoteDate } onChange={ (e) => setDelivryNoteDate(e.target.value) } onBlur={ () => setIsDelivryNoteDateTouched(true) } />
                      { isDelivryNoteDateTouched && delivryNoteDate.length === 0 && <div className='form-error'>Veuillez saisir la date livraison.</div> }
                      { errors && errors.delivry_note_date && <div className='form-error'>{ errors.delivry_note_date[0] }</div> }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='delivry_note_address' className='required'>Adresse de livraison</label>
                      <input type='text' id='delivry_note_address' name='delivry_note_address' placeholder='Adresse de livraison' className='form-control' value={ delivryNoteAddress } onChange={ (e) => setDelivryNoteAddress(e.target.value) } onBlur={ () => setIsDelivryNoteAddressTouched(true) } />
                      { isDelivryNoteAddressTouched && delivryNoteAddress.length === 0 && <div className='form-error'>Veuillez saisir l'adresse de livraison.</div> }
                      { isDelivryNoteAddressTouched && delivryNoteAddress.length > 0 && delivryNoteAddress.length < 2 && <div className='form-error'>L'adresse de livraison est trop court. Veuillez saisir au moins 2 caractères.</div> }
                      { errors && errors.delivry_note_address && <div className='form-error'>{ errors.delivry_note_address[0] }</div> }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='delivry_note_status' className='required'>Etat de livraison</label>
                      <select id='delivry_note_status' name='delivry_note_status' required className='form-control' value={ delivryNoteStatus } onChange={ (e) => setDelivryNoteStatus(e.target.value) } onBlur={ () => setIsDelivryNoteStatusTouched(true) }>
                        <option value="">Sélectionner...</option>
                        <option value="Pending">En attente</option>
                        <option value="Shipped">Expédié</option>
                        <option value="Delivered">Livré</option>
                        <option value="Failed">Echec de la livraison</option>
                        <option value="Cancelled">Annulé</option>
                        <option value="PartiallyDelivered">Partielement livré</option>
                      </select>
                      { isDelivryNoteStatusTouched && delivryNoteStatus.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de livraison.</div> }
                      { errors && errors.delivry_note_status && <div className='form-error'>{ errors.delivry_note_status[0] }</div> }
                    </div>
                  </> }
                  
                  <div className='mb-3'>
                    <label>
                      <input type='checkbox' name='generate_invoice' value={ generateInvoice } onChange={ (e) => setGenerateInvoice(e.target.checked) } />
                      <div></div>
                      Je voulais générer une facture
                    </label>
                  </div>

                  { generateInvoice && <>
                    <h6>Facture</h6>
                    <div className='mb-3'>
                      <label htmlFor='invoice_date' className='required'>Date de la facture</label>
                      <input type='date' id='invoice_date' name='invoice_date' required className='form-control' value={ invoiceDate } onChange={ (e) => setInvoiceDate(e.target.value) } onBlur={ () => setIsInvoiceDateTouched(true) } />
                      { isInvoiceDateTouched && invoiceDate.length === 0 && <div className='form-error'>Veuillez saisir la date de la facture.</div> }
                      { errors && errors.invoice_date && <div className='form-error'>{ errors.invoice_date[0] }</div> }
                    </div>
                    
                    <div className='mb-3'>
                      <label htmlFor='invoice_due_date'>Date d'échéance de la facture</label>
                      <input type='date' id='invoice_due_date' name='invoice_due_date' className='form-control' value={ invoiceDueDate } onChange={ (e) => setInvoiceDueDate(e.target.value) } />
                      { errors && errors.invoice_due_date && <div className='form-error'>{ errors.invoice_due_date[0] }</div> }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='withdrawal_fees_via_mvola'>Frais de retrait via mvola</label>
                      <input type='number' min={ 0 } step={ 0.01 } id='withdrawal_fees_via_mvola' name='withdrawal_fees_via_mvola' placeholder='Frais de retrait via mvola' className='form-control' value={ withdrawalFeesViaMvola } onChange={ (e) => setWithdrawalFeesViaMvola(e.target.value) } />
                      { errors && errors.withdrawal_fees_via_mvola && <div className='form-error'>{ errors.withdrawal_fees_via_mvola[0] }</div> }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='delivry_fees'>Frais de livraison</label>
                      <input type='number' min={ 0 } step={ 0.01 } id='delivry_fees' name='delivry_fees' placeholder='Frais de livraison' className='form-control' value={ delivryFees } onChange={ (e) => setDelivryFees(e.target.value) } />
                      { errors && errors.delivry_fees && <div className='form-error'>{ errors.delivry_fees[0] }</div> }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='shipping_fees'>Frais d'envoi</label>
                      <input type='number' min={ 0 } step={ 0.01 } id='shipping_fees' name='shipping_fees' placeholder="Frais d'envoi" className='form-control' value={ shippingFees } onChange={ (e) => setShippingFees(e.target.value) } />
                      { errors && errors.shipping_fees && <div className='form-error'>{ errors.shipping_fees[0] }</div> }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='discount'>Remise (en %)</label>
                      <input type='number' min={ 0 } step={ 0.01 } id='discount' name='discount' placeholder="Remise (en %)" className='form-control' value={ discount } onChange={ (e) => setDiscount(e.target.value) } onBlur={ () => setIsDiscountTouched(true) } />
                      { isDiscountTouched && discount.length === 0 && <div className='form-error'>Ce champ ne peut pas être vide.</div> }
                      { errors && errors.discount && <div className='form-error'>{ errors.discount[0] }</div> }
                    </div>

                    <div className='mb-3'>
                      <label htmlFor='invoice_status' className='required'>Etat de la facture</label>
                      <select id='invoice_status' name='invoice_status' required className='form-control' value={ invoiceStatus } onChange={ (e) => setInvoiceStatus(e.target.value) } onBlur={ () => setIsInvoiceStatusTouched(true) }>
                        <option value="">Sélectionner...</option>
                        <option value="Pending">En attente</option>
                        <option value="Sent">Envoyée</option>
                        <option value="Paid">Payée</option>
                        <option value="Overdue">En retard</option>
                        <option value="Cancelled">Annulée</option>
                        <option value="Refunded">Remboursée</option>
                      </select>
                      { isInvoiceStatusTouched && invoiceStatus.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la facture.</div> }
                      { errors && errors.invoice_status && <div className='form-error'>{ errors.invoice_status[0] }</div> }
                    </div>
                  </> }
                  
                  <div className='pt-2 text-end'>
                    <button type='submit' disabled={
                      items.length === 0
                    } className='btn btn-lg btn-primary'><i className="fa fa-save"></i> Enregistrer</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div ref={ detailsModalRef } className={ `_modal${ modal === "details" && order ? ' active' : '' }` }>
            <div className='_modal-content'>
              <div className='_modal-head'>
                { order && 
                <h4>Commande N° { order.code }</h4> }
                <button type='button' className='_modal-close'>&times;</button>
              </div>
              <div className='_modal-body'>
                { order && <>
                  <div className='row'>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Code</div>
                      <div className='_value'>{ order.code }</div>
                    </div>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Date de commande</div>
                      <div className='_value'>{ dateFormat(order.order_date) }</div>
                    </div>
                  </div>
                  
                  <div className='mb-3'>
                    <div className='_label'>Bon de commande</div>
                    <div className='_value'>{ order.purchase_order ? order.purchase_order : "-" }</div>
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Client</div>
                    <div className='_value'>
                      { order.client ? (order.client.type === "Company" ? order.client.company_name : order.client.last_name + " " + order.client.first_name) : '-' }
                      <br/>
                      { order.client ? order.client.address + ", " + order.client.zipcode + " " + order.client.city + ", " + order.client.country : "-" }
                      <br/>
                      { order.client ? (order.client.email ? "E-mail: " : "") + order.client.email + (order.client.phone ? (order.client.email ? " - Tél: " : "Tél: ") + order.client.phone : "") + (order.client.website ? (order.client.email || order.client.phone ? " - Site web: " : "Site web: ") + order.client.website : "") : "-" }
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Montant</div>
                      <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(order.total_amount) } Ariary</div>
                    </div>

                    <div className='col-6 mb-3'>
                      <div className='_label'>Etat</div>
                      <div className='_value'>{ order.status === "Confirmed" ? <span className='badge bg-info'>Confirmée</span> : (order.status === "Shipped" ? <span className='badge bg-success'>Expédiée</span> : ( order.status === "Delivered" ? <span className='badge bg-success'>Livrée</span> : (order.status === "Cancelled" ? <span className='badge bg-danger'>Annulée</span> : (order.status === "Returned" ? <span className='badge bg-dark'>Retournée</span> : <span className='badge bg-warning'>En attente</span>)))) }</div>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Détails</div>
                    <div className='_value'>
                      <table className='table table-striped'>
                        <thead>
                          <tr>
                            <th>Produit</th>
                            <th>Quantité</th>
                            <th>Prix unit. (Ariary)</th>
                            <th>Montant HT (Ariary)</th>
                          </tr>
                        </thead>
                        <tbody>
                          { order.items.map((item, index) => {
                            return(
                            <tr key={ index }>
                              <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                              <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                              <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price) }</td>
                              <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price * item.quantity) }</td>
                            </tr>
                            )
                          }) }
                          <tr>
                            <th colSpan={ 3 } className='text-uppercase'>Total</th>
                            <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(order.total_amount) }</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className='text-center pt-2'>
                    <button className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className='fa fa-edit'></i> Modifier</button>
                  </div>
                </> }
              </div>
            </div>
          </div>

          <div ref={ updateModalRef } className={ `_modal${ modal === "update" && order ? ' active' : '' }` }>
            <div className='_modal-content'>
              <div className='_modal-head'>
                { order && 
                <h4>Modifier la commande N° { order.code }</h4> }
                <button type='button' className='_modal-close'>&times;</button>
              </div>
              <div className='_modal-body'>
                { order &&
                <form className='form' onSubmit={ handleSubmitUpdate }>
                  { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                  <div className='mb-3'>
                    <label htmlFor='code' className='required'>Code</label>
                    <input type='text' name="code" id="code" className='form-control' value={ code } placeholder='Code' onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                    { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code commande.</div> }
                    { isCodeTouched && code.length > 0 && /^CD\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code commande n'est pas valide. Le format valide est: CD/[année]/[numéro d'ordre].</div> }
                    { orders && orders.code && <div className='form-error'>{ errors.code[0] }</div> }
                  </div>

                  <div className='mb-3'>
                    <label htmlFor='_order_date' className='required'>Date de commande</label>
                    <input type='date' name='order_date' id='_order_date' required className='form-control' value={ orderDate } onChange={ (e) => setOrderDate(e.target.value) } onBlur={ () => setIsOrderDateTouched(true) } />
                    { isOrderDateTouched && orderDate.length === 0 && <div className='form-error'>Veuillez saisir la date de la commande.</div> }
                    { orders && orders.order_date && <div className='form-error'>{ errors.order_date[0] }</div> }
                  </div>
                  
                  <div className='mb-3'>
                    <label htmlFor='_purchase_order'>N° de bon de commande</label>
                    <input type='text' name='purchase_order' id='_purchase_order' placeholder='N° de bon de commande' className='form-control' value={ purchaseOrder } onChange={ (e) => setPurchaseOrder(e.target.value) } onBlur={ () => setIsPurchaseOrderTouched(true) } />
                    { isPurchaseOrderTouched && purchaseOrder.length > 0 && purchaseOrder.length < 2 && <div className='form-error'>Le numéro de bon de commande est trop court. Veuillez saisir au moins 2 caractères.</div> }
                    { orders && orders.purchase_order && <div className='form-error'>{ errors.purchase_order[0] }</div> }
                  </div>
                  
                  <div className='mb-3'>
                    <label htmlFor='_client_id' className='required'>Client</label>
                    <input type='hidden' name='client_id' className='form-control' value={ client ? client.id : "" } />
                    <SearchClient updateClient={ setClient } id='_client_id' required={ true } reset={ modal !== "update" } defaultValue={ client } />
                    { orders && orders.client_id && <div className='form-error'>{ errors.client_id[0] }</div> }
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Produits</div>
                    <div className='_value'>
                      <table className='table table-striped'>
                        <thead>
                          <tr>
                            <th width="50px"></th>
                            <th>Nom du produit</th>
                            <th>Quantité</th>
                          </tr>
                        </thead>
                        <tbody>
                          { order.items.map((item, index) => {
                            return(
                            <tr key={ index }>
                              <td>
                                <button type='button' className='delete_product_button' onClick={ () => {
                                    deteteOrderItem(item.id);
                                }}><i className='fa fa-trash'></i></button>
                              </td>
                              <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                              <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                            </tr>
                            )
                          }) }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  { items.map((item, index) => {
                    return(
                      <OrderItem item={ index } id='_product' itemKey={ item.key } key={ item.key } onRemove={ removeItem } errors={ errors } reset={ modal !== "add" } />
                    )
                  }) }
                  
                  <div className='mb-3 text-end'>
                    <button type='button' onClick={ addItem } className='btn btn-sm btn-info'><i className='fa fa-plus'></i> Ajouter un produit</button>
                  </div>

                  <div className='mb-3'>
                    <label htmlFor='_status' className='required'>Etat de la commande</label>
                      <select id='_status' name='status' required className='form-control' value={ status } onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                        <option value="">Sélectionner...</option>
                        <option value="Pending">En attente</option>
                        <option value="Confirmed">Confirmée</option>
                        <option value="Shipped">Expédiée</option>
                        <option value="Delivered">Livrée</option>
                        <option value="Cancelled">Annulée</option>
                        <option value="Returned">Retournée</option>
                      </select>
                      { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la commande.</div> }
                      { orders && orders.status && <div className='form-error'>{ errors.status[0] }</div> }
                  </div>

                  <div className='pt-2 text-center'>
                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                      code.length === 0 || orderDate.length === 0 || client === null || status.length === 0 ||
                      (modal === "update" && order && code === order.code && orderDate === order.order_date && status === order.status && order.client === client && items.length === 0 && ((order.purchase_order === null && purchaseOrder.length === 0) || (order.purchase_order !== null && purchaseOrder === order.purchase_order)))
                    }><i className='fa fa-edit'></i> Mettre à jour</button>
                  </div>
                </form> }
              </div>
            </div>
          </div>

          <div className='box'>
            <table className='table table-striped'>
            <thead>
              <tr>
                <th width="100">Code</th>
                <th width="100">Date</th>
                <th>Client</th>
                <th>Montant</th>
                <th width="120">Statut</th>
                <th width="75" className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              { orders.loading && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
              { orders.loading === false && orders.data && orders.data.total === 0 && <tr><td colSpan={ 6 }>Aucun élément trouvé</td></tr> }
              { orders.loading === false && orders.data && orders.data.data && orders.data.data.map((item, index) => {
                return (
                <tr key={ index }>
                  <td>{ item.code }</td>
                  <td>{ dateFormat(item.order_date) }</td>
                  <td>{ item.client ? (item.client.type === 'Company' ? item.client.company_name : item.client.last_name + " " + item.client.first_name) : 'Non renseigné' }</td>
                  <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.total_amount) } Ariary</td>
                  <td>
                    { item.status === "Confirmed" ? <span className='badge bg-info'>Confirmée</span> : (item.status === "Shipped" ? <span className='badge bg-success'>Expédiée</span> : ( item.status === "Delivered" ? <span className='badge bg-success'>Livrée</span> : (item.status === "Cancelled" ? <span className='badge bg-danger'>Annulée</span> : (item.status === "Returned" ? <span className='badge bg-dark'>Retournée</span> : <span className='badge bg-warning'>En attente</span>)))) }
                  </td>
                  <td className="text-end">
                    <div className='actions'>
                      <button type='button' className='toggle-action' onClick={ (e) => {
                        e.stopPropagation();
                        setActionModal(actionModal !== item.id ? item.id : null);
                      } }><i className='fa fa-ellipsis-v'></i></button>
                      <ul className={ actionModal === item.id ? 'active' : '' }>
                        <li><button type='button' onClick={ () => {
                          setActionModal(null);
                          setOrder(item);
                          setModal("details");
                        } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                        <li><button type='button' onClick={ () => {
                          setActionModal(null);
                          setOrder(item);
                          setModal("update");  
                        } }><i className="fa fa-edit"></i> Modifier</button></li>
                      </ul>
                    </div>
                  </td>
                </tr> ) })}
              </tbody>
            </table>
          </div>

          { orders && orders.data &&
          <Paginate currentPage={ orders.data.current_page } totalPages={ orders.data.last_page } pathname={ location.pathname } search={ location.search } /> }          
        </main>
    </HelmetProvider>
  )
}
